import { MESSAGE_MODE } from 'src/constants/messageMode';
import ManageMessage from 'src/sections/view_message/ManageMessage';
import ViewMessageContextProvider from 'src/sections/view_message/ViewMessageContextUnified';

export const ViewMessagesOutbox = () => (
  <ViewMessageContextProvider initialMode={MESSAGE_MODE.OUTBOX}>
    <ManageMessage mode={MESSAGE_MODE.OUTBOX} />
  </ViewMessageContextProvider>
);

export const ViewMessagesInbox = () => (
  <ViewMessageContextProvider initialMode={MESSAGE_MODE.INBOX}>
    <ManageMessage mode={MESSAGE_MODE.INBOX} />
  </ViewMessageContextProvider>
);
